import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FEATURES } from "@/lib/content";

export default function Features() {
  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-14 pt-8 pb-24">
      <div className="max-w-2xl">
        <div className="overline text-cobalt-500">Features</div>
        <h1 className="mt-2 font-display text-5xl sm:text-6xl font-black tracking-tighter leading-[0.95]">
          One platform for the<br />whole event lifecycle.
        </h1>
        <p className="mt-5 text-lg text-muted-foreground leading-relaxed">
          From the first hall request to the last certificate, every step lives in one place —
          scoped to the right people at each stage.
        </p>
      </div>

      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {FEATURES.map((f, i) => {
          const Icon = f.icon;
          return (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 3) * 0.05 }}
              className="glass rounded-2xl p-6 card-hover relative overflow-hidden group"
            >
              <div className="absolute -top-10 -right-10 h-28 w-28 rounded-full bg-cobalt-500/10 blur-2xl opacity-60" />
              <div className="relative">
                <div className="h-11 w-11 rounded-xl bg-cobalt-500/10 text-cobalt-500 grid place-items-center"><Icon className="h-5 w-5" /></div>
                <h3 className="mt-4 font-display text-xl font-extrabold tracking-tighter">{f.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{f.desc}</p>
                {f.detail && (
                  <details className="mt-3 group/det">
                    <summary className="text-[11px] uppercase tracking-widest text-cobalt-500 font-mono cursor-pointer hover:underline">Looking under the hood</summary>
                    <p className="mt-2 text-xs text-muted-foreground leading-relaxed">{f.detail}</p>
                  </details>
                )}
              </div>
            </motion.div>
          );
        })}
      </div>

      <div className="mt-14 glass-strong rounded-3xl p-10 text-center relative overflow-hidden">
        <div className="absolute -top-20 -right-20 h-60 w-60 rounded-full bg-cyanx/30 blur-3xl opacity-40" />
        <div className="relative">
          <h2 className="font-display text-3xl sm:text-4xl font-black tracking-tighter">See it on your own campus.</h2>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link to="/how-it-works"><Button size="lg" className="rounded-full h-12 px-6">How it works <ArrowUpRight className="ml-1.5 h-4 w-4" /></Button></Link>
            <Link to="/login"><Button variant="outline" size="lg" className="rounded-full h-12 px-6">Sign in</Button></Link>
          </div>
        </div>
      </div>
    </div>
  );
}
